var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grade_main"},[_c('div',{staticClass:"head"},[_vm._v("学生缺勤信息")]),_c('div',{staticClass:"grade_top"},[_c('now-info',{ref:"nowInfo"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }